import '../css/Skeletons.css';

export const FieldResultSkeleton = () => (
  <div className="ff-card ff-result-skeleton" aria-hidden="true">
    <div className="ff-skeleton ff-result-skeleton-image" />
    <div className="ff-result-skeleton-lines">
      <div className="ff-skeleton ff-result-skeleton-title" />
      <div className="ff-skeleton ff-result-skeleton-subtitle" />
    </div>
  </div>
);

export const SearchResultsSkeleton = ({ count = 4 }) => (
  <div className="ff-skeleton-list" data-testid="search-results-skeleton">
    {Array.from({ length: count }, (_, index) => (
      <FieldResultSkeleton key={index} />
    ))}
  </div>
);

export const FieldPageSkeleton = () => (
  <div className="ff-content" data-testid="field-page-skeleton" aria-hidden="true">
    <div className="ff-skeleton ff-field-skeleton-title" />
    <div className="ff-skeleton ff-field-skeleton-subtitle" />
    <div className="ff-skeleton ff-field-skeleton-hero" />
    <div className="ff-skeleton ff-field-skeleton-block" />
    <div className="ff-skeleton ff-field-skeleton-block" />
  </div>
);
